import type { FaireProductEntity } from "../../entity_types/product";

export const p_wjzshhvj4m: FaireProductEntity = {
  token: "p_wjzshhvj4m",
  type: "product",
  name: "Dark Chocolate Coconut Bar Caddy - 40 Bars",
  brandToken: "b_6wib61r9",
  brandName: "UNREAL",
  imageUrl:
    "https://cdn.faire.com/fastly/c96f4b168ee1c051c97b758d3923687957cbcc784155a96d05416b1c758b7456.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/445ffaa10632033eab15ef3839956c94b468e8ac14afe864419985aceb38a066.png",
    "https://cdn.faire.com/fastly/2255adce04d1ea79edfebe4f654c71cc02d413f0db9809bcee72022fbec4bf1e.png",
  ],
  priceDollars: 40.18,
  description:
    "\nThis caddy contains 40 individually wrapped .53oz snack size coconut bars\n\nSRP: $0.99 for each individually wrapped cup\n\n * 3 SIMPLE INGREDIENTS: Organic Coconut, Organic Cassava Syrup & Dark Chocolate \n * ONLY 3G SUGAR: we keep sugar to a minimum, without using sugar alcohols or artificial sweeteners. We carefully formulate our coconut bars with only the best, quality ingredients that put flavor first without all of the sugar. \n * INDIVIDUALLY WRAPPED: Each bag contains 8 individually wrapped dark chocolate coconut bars. \n * ALL-NATURAL: our coconut bars are non-gmo project verified and made in small batches with fair trade certified ingredients. ",
  tags: [],
  msrpDollars: 55.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:40.942Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
